import React from "react"
import Svg from "../_svgs/svg"

const AllowedItemsPageDescription = ({ descriptionIcons, disclaimerText }) => {
  return (
    <div className="items-list-inner">
      {descriptionIcons && descriptionIcons.length > 0 ? (
        <div className={`icon-descriptions ${disclaimerText ? "no-bottom-padding" : ""}`}>
          <div className="icon-descriptions-inner">
            {descriptionIcons.map((item, index) => {
              return (
                <div className="item" key={index}>
                  <Svg
                    iconName={item.icon}
                    stroke={"#FFF"}
                    fillColor={item.iconColor}
                    label={item.iconAriaLabel}
                    isDecorative={!item.iconAriaLabel}
                  />
                  <span className="text" aria-label={item.textAriaLabel}>
                    {item.text}
                  </span>
                </div>
              )
            })}
          </div>
        </div>
      ) : (
        ""
      )}
      {disclaimerText ? <div className="disclaimer-box" dangerouslySetInnerHTML={{ __html: disclaimerText }}></div> : ""}
    </div>
  )
}

export default AllowedItemsPageDescription
